module.exports = __webpack_public_path__ + "static/media/noe-lamp-img3.00797093.jpg";